import { Button, Icon, Intent, Spinner, Position } from '@blueprintjs/core';
import { Tooltip2 } from '@blueprintjs/popover2';

import { RetrosynthesisLinkParams, useSciFinderRetrosynthesis } from '@f/hooks/useSciFinderRetrosynthesis';

interface ButtonTextOptions {
  hasLink: boolean;
  isLoading: boolean;
  isCheckingStatus: boolean;
}

function getButtonText(options: ButtonTextOptions) {
  const { hasLink, isLoading, isCheckingStatus } = options;
  if (isLoading) {
    return 'Generating full retrosynthesis in SciFinder';
  }
  if (isCheckingStatus) {
    return 'Checking status of search in SciFinder';
  }
  if (hasLink) {
    return 'Open full retrosynthesis in SciFinder';
  }
  return 'Generate full retrosynthesis in SciFinder';
}

export function RetrosynthesisButton(params: RetrosynthesisLinkParams) {
  const { isLoading, isCheckingStatus, link, openLink, openRetrosynthesis } = useSciFinderRetrosynthesis(params);

  const isLoadingOrCheckingStatus = isLoading || isCheckingStatus;

  return (
    <Tooltip2
      content={<small>Please allow RetroScore to open popup windows if prompted.</small>}
      position={Position.TOP}
      disabled={Boolean(link)}
    >
      <Button
        icon="open-application"
        rightIcon={
          <>
            {isLoadingOrCheckingStatus && <Spinner size={14} />}
            {link && <Icon icon="tick-circle" intent={Intent.SUCCESS} />}
          </>
        }
        text={getButtonText({ hasLink: Boolean(link), isLoading, isCheckingStatus })}
        onClick={() => {
          if (link) {
            openLink(link);
            return;
          }
          openRetrosynthesis(params);
        }}
        disabled={isLoadingOrCheckingStatus}
        data-cy="button-scifinder-retrosynthesis"
      />
    </Tooltip2>
  );
}
